export default "$ yarn add @nuxtjs/vuetify -D\n# OR\n$ npm install @nuxtjs/vuetify -D\n";